import { render, staticRenderFns } from "./exceptionList.vue?vue&type=template&id=21480381&"
import script from "./exceptionList.vue?vue&type=script&lang=js&"
export * from "./exceptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports